import { CenterV } from '@/fabritor/components/Center';
import { PANEL_WIDTH } from '@/config';
import { Trans } from '@/i18n/utils';
import { getBrandConfig } from '@/utils/brand';

type LogoProps = {
  onClick?: () => void
}

export default function Logo(props: LogoProps) {
  const { brandLogo } = getBrandConfig()
  return (
    <CenterV
      gap={5} 
      style={{ width: PANEL_WIDTH, paddingLeft: 16 }}
    >
      <img 
        src={brandLogo} 
        style={{ 
          width: 32, 
          cursor: 'pointer',
          transform: 'scale(1)',
          transition: 'transform 0.3s cubic-bezier(0.34, 1.56, 0.64, 1)'
        }}
        onClick={props.onClick}
        onMouseOver={(e) => e.currentTarget.style.transform = 'scale(1.1)'}
        onMouseOut={(e) => e.currentTarget.style.transform = 'scale(1)'}
      />
      <span 
        style={{ 
          fontSize: '14px', 
          fontWeight: 500, 
          color: '#4a4a4a', 
          cursor: 'pointer', 
          transition: 'all 0.4s cubic-bezier(0.34, 1.56, 0.64, 1)',
          letterSpacing: '1px',
          userSelect: 'none',
          fontFamily: '"PingFang SC", "Microsoft YaHei", sans-serif',
          opacity: 0.9,
          paddingTop: '4px'
        }} 
        onClick={props.onClick}
        onMouseOver={(e) => {
          e.currentTarget.style.color = '#1a1a1a';
          e.currentTarget.style.letterSpacing = '1.5px';
          e.currentTarget.style.opacity = '1';
        }} 
        onMouseOut={(e) => {
          e.currentTarget.style.color = '#4a4a4a';
          e.currentTarget.style.letterSpacing = '1px';
          e.currentTarget.style.opacity = '0.9';
        }}
      >
        <Trans i18nKey="header.logo.back_to_space" />
      </span>
    </CenterV>
  );
}
